export default __webpack_public_path__ + "static/media/woo-woo, soothing, professional.04ac0a09.jpg";